import { render, staticRenderFns } from "./templatesListSkeleton.vue?vue&type=template&id=02bed3ee&scoped=true&"
import script from "./templatesListSkeleton.vue?vue&type=script&lang=js&"
export * from "./templatesListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./templatesListSkeleton.vue?vue&type=style&index=0&id=02bed3ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bed3ee",
  null
  
)

export default component.exports